// src/components/BreakpointDebugger.jsx
import React from "react";
import { useTheme, useMediaQuery, Box } from "@mui/material";

const BreakpointDebugger = () => {
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));

  let label = "Unknown";
  let color = "#9e9e9e";

  if (isXs) { label = "<600px"; color = "#ef5350"; } //XS - Mobile (<600px)
  else if (isSm) { label = "<900px"; color = "#ffb300"; } //SM - Small Tablet (600–900px)
  else if (isMd) { label = "<1200px"; color = "#66bb6a"; } //MD - Tablet (900–1200px)
  else if (isLg) { label = "<1536px"; color = "#42a5f5"; } //LG - Desktop (1200–1536px)
  else if (isXl) { label = "1536px+"; color = "#ab47bc"; } //XL - Large Desktop (1536px+)

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        right: 0,
        backgroundColor: color,
        color: "#fff",
        fontSize: "0.75rem",
        fontWeight: 600,
        padding: "2px 5px",
        borderRadius: 2,
        zIndex: 99999,
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        pointerEvents: "none",
        userSelect: "none",
      }}
    >
      {label}
    </Box>
  );
};

export default BreakpointDebugger;
